export default {"src":"/_next/static/image/src/images/Footer/facebook.e5bdebdf2632b75319d2e6ae442a8b7b.svg","height":20,"width":12};